import React from 'react';
import {POLICIES} from '../../../constants/policies';

/**
 * Подробные правила политик для раздела правил «Политики» (блок внизу
 * страницы). Оформление — как у подробных правил фракций: абзацы обычного
 * текста со значками интерфейса.
 *
 * Реестр: id политики -> компонент правил. Политика без записи в реестре
 * просто не получает блок (см. PoliciesRules).
 */

const statIcon = (src, alt) => (
  <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={src}
    alt={alt}
    title={alt}
  />
);

const buildingIcon = (src, alt) => (
  <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={src}
    alt={alt}
    title={alt}
  />
);

const unitIcon = (src, alt) => (
  <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={src}
    alt={alt}
    title={alt}
  />
);

export const POLICY_RULES_ICONS = {
  coins: statIcon('/img/icons/coins.png', 'Монеты'),
  coinsPlusOne: statIcon('/img/icons/coins.png', 'Монеты за размер'),
  supply: statIcon('/img/icons/supply.png', 'Снабжение'),
  damage: statIcon('/img/icons/damage.png', 'Урон'),
  size: statIcon('/img/icons/unit size.png', 'Размер отряда'),
  winPoints: statIcon('/img/icons/win points.png', 'Победные очки'),
  action: statIcon('/img/icons/action.png', 'Действие'),
  initiative: statIcon('/img/icons/action initiative active.png', 'Инициатива'),
  speed: statIcon('/img/icons/speed.png', 'Перемещение'),
  city: statIcon('/img/icons/city.42008716.png', 'Город'),
  farm: buildingIcon('/img/hexes/farm.699e6dfc.png', 'Ферма'),
  barracks: buildingIcon('/img/hexes/barracks.efab12f7.png', 'Казарма'),
  mine: buildingIcon('/img/hexes/mine.ecae90cd.png', 'Рудник'),
  superMine: buildingIcon('/img/hexes/super_mine.7a4a81f7.png', 'Великий рудник'),
  ruins: buildingIcon('/img/hexes/ruins.65862e11.png', 'Руины'),
  superRuins: buildingIcon('/img/hexes/super_ruins.97515170.png', 'Великие руины'),
  quarter: buildingIcon('/img/hexes/quarter.f69660fa.png', 'Квартал'),
  centralQuarter: buildingIcon('/img/icons/central quarter.7dd51bfd.png', 'Центральный квартал'),
  specialBuilding: buildingIcon('/img/hexes/special buildings/special building.c496c562.png', 'Специальное строение'),
  guild: buildingIcon('/img/hexes/special buildings/guild.ee26d2b8.png', 'Гильдия'),
  temple: buildingIcon('/img/hexes/special buildings/temple.17c08b3d.png', 'Храм'),
  warehouse: buildingIcon('/img/hexes/special buildings/warehouse.adf397b3.png', 'Склад'),
  militaryCamp: buildingIcon('/img/hexes/special buildings/military camp.1216e2cd.png', 'Военный лагерь'),
  arsenal: buildingIcon('/img/hexes/special buildings/arsenal.7f5423b5.png', 'Арсенал'),
  fortress: buildingIcon('/img/hexes/special buildings/fortress.05d960f6.png', 'Крепость'),
  unit: unitIcon('/img/icons/unit d6 friend.png', 'Отряд'),
  enemyUnit: unitIcon('/img/icons/unit d6 enemy.png', 'Отряд противника'),
  catapult: unitIcon('/img/icons/unit d4 friend.png', 'Катапульта'),
};

const {
  coins, damage, size, action, unit, catapult, winPoints, supply, initiative, speed, city,
  militaryCamp, arsenal, guild, warehouse, fortress, temple, specialBuilding,
  mine, superMine, quarter, centralQuarter, barracks, farm, ruins, superRuins,
} = POLICY_RULES_ICONS;

const DespotismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Дешёвый найм отрядов.</span></b>{' '}
      Найм нового отряда {unit} обходится дешевле — скидка тем больше, чем лучше тип
      отряда: Пехота <b>2 → 1</b> монета {coins}, Тяжёлая пехота <b>5 → 3</b>, Элитная пехота <b>10 → 7</b>,
      Лёгкая кавалерия <b>6 → 4</b>, Тяжёлая кавалерия <b>8 → 6</b>. Катапульты {catapult} скидки не
      получают, и на докупку размера {size} она тоже не распространяется — только на найм самого отряда.
    </p>
    <p>
      <b><span className={'text-construction'}>Дешёвый Военный лагерь.</span></b>{' '}
      Лагерь {militaryCamp} стоит <b>4 монеты</b> вместо 8.
    </p>
  </>
);

const MilitarismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Увеличенный урон в ближнем бою.</span></b>{' '}
      Каждый отряд {unit} бьёт сильнее, и прибавка зависит от типа:
      Пехота <b>+1</b> к урону {damage}, Тяжёлая пехота <b>+2</b>, Элитная пехота <b>+4</b>, Лёгкая
      кавалерия <b>+2</b>, Тяжёлая кавалерия <b>+4</b>. Катапульты {catapult} бонуса не получают.
    </p>
    <p>
      <b><span className={'text-construction'}>С Военным лагерем — ещё больше.</span></b>{' '}
      Если у игрока есть хотя бы один незаблокированный лагерь
      {militaryCamp}, прибавка растёт до <b>+2 / +3 / +5 / +3 / +5</b> соответственно. Лагерь работает
      <b> на всю армию</b>: отряду не нужно стоять рядом с ним или даже в том же городе.
    </p>
    <p>
      Бонус действует только в ближнем бою — стрельбу он не усиливает. Как и любые прибавки урона, суммарный
      бонус не может превысить текущий размер {size} самого отряда.
    </p>
  </>
);

const IndustrialismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Дополнительное действие.</span></b>{' '}
      В каждой своей <span className={'text-construction'}>фазе
      Строительства</span> игрок получает <b>+1 действие</b> {action}: обычно 2 → <b>3</b>, а в первом раунде
      партии 4 → <b>5</b>. Бонус складывается с действиями от Дворцов.
    </p>
    <p>
      <b><span className={'text-construction'}>Скидка на особые строения.</span></b>{' '}
      <b>−3 монеты</b> {coins} на Дворец (10 → 7), Склад {warehouse} (10 →
      7), Военный лагерь {militaryCamp} (8 → 5), Арсенал {arsenal} (8 → 5) и Крепость {fortress} (8 → 5).
      Храм {temple} и Гильдия {guild} под скидку <b>не попадают</b>.
    </p>
  </>
);

const PatriotismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Дешёвый найм размера.</span></b>{' '}
      Каждая покупка размера {size} отряда обходится на <b>1 монету</b> {coins}
      дешевле, и скидка работает для <b>всех</b> типов отрядов: пехоте всех видов <b>2 → 1</b> монета,
      кавалерии и катапультам {catapult} <b>3 → 2</b>.
    </p>
    <p>
      <b><span className={'text-construction'}>Дешёвый Арсенал.</span></b>{' '}
      Арсенал {arsenal} стоит <b>4 монеты</b> вместо 8. Это выгодное сочетание: в
      городе с рабочим арсеналом одна покупка даёт сразу <b>+2 размера</b>, то есть патриот получает два
      размера за одну монету.
    </p>
    <p>
      На цену найма самих отрядов {unit} политика не влияет — только на докупку размера.
    </p>
  </>
);

const OligarchyRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Две гильдии в одном городе.</span></b>{' '}
      Обычно каждое особое строение можно построить <b>только по одному
      на город</b>. Олигархия снимает это ограничение для гильдий {guild}: в одном городе их может быть
      <b> две</b> (третью — уже нельзя). Для остальных особых строений правило «одно на город» остаётся.
    </p>
    <p>
      <b><span className={'text-construction'}>Увеличенный доход гильдий.</span></b>{' '}
      Каждая гильдия приносит на <b>1 монету</b> {coins} больше. Доход
      гильдии складывается из базовой монеты, путей влияния до вражеских городов и этой прибавки; в конце
      раунда его приносят только незаблокированные врагом гильдии.
    </p>
  </>
);

const HegemonismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Центр поля.</span></b>{' '}
      Все бонусы политики работают в <b>центральной зоне</b> карты — это центральная
      ячейка поля и всё в радиусе <b>2 ячеек</b> вокруг неё (19 ячеек). Зона не зависит от того, чья это
      территория.
    </p>
    <p>
      <b><span className={'text-construction'}>Очки за владения в центре.</span></b>{' '}
      Каждый свой квартал {quarter} в зоне приносит <b>+1 победное
      очко</b> {winPoints} дохода (центральный квартал {centralQuarter} тоже считается), а каждый свой храм
      {temple} — <b>+2 очка</b>. Храм стоит на квартале, поэтому квартал с храмом в центре даёт сразу
      <b> +4 очка</b>. Как обычно, заблокированные врагом строения дохода не приносят.
    </p>
    <p>
      <b><span className={'text-construction'}>Бой в центре.</span></b>{' '}
      Отряд {unit}, стоящий в центральной зоне, получает <b>+3</b> к урону {damage} в
      ближнем бою — независимо от того, кому принадлежит ячейка. Суммарный бонус урона не может превысить
      размер {size} отряда.
    </p>
  </>
);

const BarbarismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Бесплатная пехота.</span></b>{' '}
      Найм обычной Пехоты {unit} (максимальный размер 6) стоит <b>0 монет</b> {coins} вместо 2. Остальные правила
      найма прежние: один отряд на казарму {barracks}, не более 4 отрядов одного типа, нанятый отряд
      появляется размером {size} 1.
    </p>
    <p>
      <b><span className={'text-construction'}>Увеличенный урон.</span></b>{' '}
      Любой отряд получает <b>+2</b> к урону {damage} в ближнем бою — без всяких
      условий и для всех типов отрядов. Суммарный бонус урона не может превысить размер отряда.
    </p>
    <p>
      <b><span className={'text-construction'}>Очки за пролитую кровь.</span></b>{' '}
      После ближнего боя игрок получает <b>+1 победное очко</b> {winPoints}
      <b> за каждый свой отряд</b>, нанёсший в этом бою хотя бы 1 урон. Считаются именно отряды, а не
      количество урона: отряд, нанёсший 10 размера, приносит то же 1 очко. Очки начисляются сразу, помимо
      обычных очков за уничтоженные отряды.
    </p>
    <p>
      <b><span className={'text-construction'}>Живучесть без снабжения.</span></b>{' '}
      Отряд, оставшийся без снабжения {supply}, теряет всего <b>1 размер</b> вместо обычных 2.
    </p>
  </>
);

const TotalitarianismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Очки за военные строения.</span></b>{' '}
      В доход добавляется <b>+1 победное очко</b> {winPoints} <b>за каждые
      два</b> работающих военных строения: считаются казармы {barracks}, арсеналы {arsenal} и военные лагеря
      {militaryCamp} во всех городах игрока. Счёт общий, остаток отбрасывается: 2 строения дадут +1 очко, 3 строения — тоже +1,
      4 — уже +2. Заблокированные врагом строения не считаются.
    </p>
    <p>
      <b><span className={'text-construction'}>Скидка на военные постройки.</span></b>{' '}
      Арсенал {arsenal} и военный лагерь {militaryCamp} стоят
      <b> 6 монет</b> {coins} вместо 8.
    </p>
    <p>
      <b><span className={'text-construction'}>Отряды приходят крупнее.</span></b>{' '}
      Нанятый отряд появляется сразу увеличенного размера {size}, притом за
      обычную цену: Тяжёлая пехота — <b>3</b>, Элитная пехота — <b>6</b>, Лёгкая кавалерия — <b>3</b>,
      Тяжёлая кавалерия — <b>4</b>. <br/>Обычная Пехота {unit} и катапульты {catapult} по-прежнему нанимаются размером 1.
    </p>
  </>
);

const ServarianismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Рудники под охраной.</span></b>{' '}
      Каждый свой рудник {mine} приносит дополнительные монеты {coins}, если
      рядом с ним есть военная сила:
    </p>
    <p>
      • <b>+1 монета</b>, если смежно с рудником стоит своя работающая казарма {barracks};
      <br/>• <b>+1 монета</b>, если смежно с рудником стоит свой отряд {unit} размером {size} <b>7 и
      больше</b>.
    </p>
    <p>
      Условия независимы и складываются — рудник рядом и с казармой, и с крупным отрядом даст <b>+2
      монеты</b>. Больше одной прибавки за категорию получить нельзя, сколько бы казарм или крупных отрядов
      ни стояло вокруг. Отряд, стоящий прямо <b>на</b> руднике, тоже считается соседним. Бонус работает и для
      великих рудников {superMine}.
    </p>
  </>
);

const FortificationismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Мгновенное строительство.</span></b>{' '}
      Обычно построенная крепость {fortress} до конца раунда стоит «в
      лесах»: она не защищает отряд и не перекрывает линию выстрела. У фортификациониста крепость
      <b> работает сразу</b> — уже в фазе Войны того же раунда она поглощает урон и служит препятствием для
      обстрела.
    </p>
    <p>
      <b><span className={'text-construction'}>Дешёвые крепости.</span></b>{' '}
      Крепость стоит <b>4 монеты</b> {coins} вместо 8.
    </p>
    <p>
      <b><span className={'text-construction'}>Ремонт сам собой.</span></b>{' '}
      В конце каждого раунда каждая крепость игрока <b>чинит 1 повреждение</b> —
      обычный ремонт стоил бы действия в фазе Строительства.
    </p>
    <p>
      <b><span className={'text-construction'}>Бой у стен.</span></b>{' '}
      Отряд {unit} получает <b>+3</b> к урону {damage} в ближнем бою, если <b>смежно</b>
      с ним стоит крепость — или если он стоит <b>на самой крепости</b>.<br/>Бонус даётся один раз, даже если
      крепостей рядом несколько, и не может превысить размер {size} отряда.<br/>Бонус даётся даже смежно вражеским крепостям.
    </p>
  </>
);

const EcoanarchismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Снабжение куда угодно.</span></b>{' '}
      Обычно снабжение {supply} идёт от фермы {farm} цепочкой по непустым
      ячейкам, не дальше 5 шагов, в обход гор, воды и вражеских отрядов. У экоанархиста <b>всех этих
      ограничений нет</b>: ферма снабжает <b>любой свой отряд {unit} в любой точке поля</b>. Сама ферма при этом должна быть не заблокирована и иметь неизрасходованное снабжение, а
      отряд по-прежнему получает не больше базового и одного дополнительного снабжения за ход.
    </p>
    <p>
      <b><span className={'text-construction'}>Пустые ячейки не мешают идти.</span></b>{' '}
      Для всех остальных пустая ячейка — тупик: встать на неё можно, но перемещение в таком случае заканчивается для отряда в текущем раунде. Отряды экоанархиста <b>проходят пустые ячейки насквозь</b> и тратят
      на них обычное перемещение {speed}. Сама дальность хода при этом не увеличивается. Пустая ячейка, занятая своим
      отрядом, экоанархиста тоже не останавливает: сквозь неё можно пройти, встать на неё — по-прежнему нельзя.
    </p>
    <p>
      <b><span className={'text-construction'}>Манёвр откуда угодно.</span></b>{' '}
      Манёвр в конце фазы Войны обычно доступен только с ячейки со строением
      или ключевой точкой — экоанархист манёврирует и с <b>пустой ячейки</b>. Прочие условия манёвра прежние:
      дополнительное снабжение и участие отряда в стрельбе или бою в этой фазе.
    </p>
  </>
);

const TheocracyRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Увеличенный доход храмов.</span></b>{' '}
      Каждый храм {temple} приносит на <b>2 победных очка</b> {winPoints}
      больше обычного. Доход считается за каждый незаблокированный врагом храм и складывается с очками за
      пути влияния до вражеских городов.
    </p>
    <p>
      <b><span className={'text-construction'}>Бой под сенью храма.</span></b>{' '}
      Отряд {unit} получает <b>+1</b> к урону {damage} в ближнем бою, если стоит
      на любой ячейке города {city}, в котором есть храм: центральный квартал, кварталы, фермы, казармы,
      рудники или руины этого города. Важно: годится <b>любой</b> город с храмом, в том числе <b>чужой</b> —
      достаточно, чтобы отряд бился на его земле. Суммарный бонус урона не может превысить размер {size}
      отряда.
    </p>
  </>
);

const FanaticismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Увеличенный доход руин.</span></b>{' '}
      Каждые руины {ruins} в городах игрока приносят на <b>2 победных
      очка</b> {winPoints} больше. Прибавка одинаковая и для обычных, и для великих руин {superRuins}.
      <br/>В последних 3 раундах матча, когда Руины приносят удвоенный доход очков, бонус Фанатизма остается таким же:
      за обычные Руины фанатик получает 6 очков (не фанатик — 4), за Великие Руины — 10 очков (не фанатик — 8).
    </p>
    <p>
      <b><span className={'text-construction'}>Ярость у руин.</span></b>{' '}
      Отряд {unit} получает прибавку к урону {damage} в ближнем бою, если стоит
      <b> на руинах</b> или <b>смежно</b> с ними: Пехота <b>+1</b>, Лёгкая кавалерия <b>+2</b>, Тяжёлая
      пехота <b>+2</b>, Тяжёлая кавалерия <b>+3</b>, Элитная пехота <b>+3</b>. Годятся любые руины, включая
      чужие и ничейные; суммарный бонус не может превысить размер {size} отряда.
    </p>
    <p>
      <b><span className={'text-construction'}>Обмен очков на монеты.</span></b>{' '}
      Кнопкой в футере фанатик меняет <b>3 победных очка</b> {winPoints} на
      <b> 4 монеты</b> {coins}. Обмен доступен <b>один раз за раунд</b> в свой ход, действий фазы
      Строительства {action} не тратит.
    </p>
  </>
);

const AgrarianismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Первая ферма — почти даром.</span></b>{' '}
      Первая ферма {farm}, построенная в <b>каждой</b> своей фазе
      Строительства, стоит <b>2 монеты</b> {coins} вместо 3 и <b>не тратит действие</b> {action}. Вторая и
      последующие фермы в том же ходу строятся по обычным правилам.
    </p>
    <p>
      <b><span className={'text-construction'}>Дешёвый склад.</span></b>{' '}
      Склад {warehouse} стоит <b>6 монет</b> вместо 10.
    </p>
    <p>
      <b><span className={'text-construction'}>Обмен снабжения на монеты.</span></b>{' '}
      В свой ход в фазе Снабжения можно продать неиспользованное снабжение
      {supply}: <b>3 единицы дают 2 монеты</b>, <b>2 единицы — 1 монету</b>. Обменивать можно минимум две
      единицы; «лишняя» непарная единица не тратится и остаётся отряду. Выбранные для обмена единицы вернуть
      уже нельзя. Если выбор из двух и более единиц не подтвердить, обмен произойдёт сам при завершении хода — в
      том числе когда в сетевой игре истекает общее время фазы Снабжения.
    </p>
  </>
);

const IsolationismRules = () => (
  <>
    <p>
      <b><span className={'text-construction'}>Защита права первого хода.</span></b>{' '}
      У изоляциониста, владеющего инициативой {initiative},
      <b> нельзя перехватить право первого хода</b> — кнопка перехвата у соперников не сработает. Защита
      начинает действовать <b>сразу после покупки</b> политики, не дожидаясь следующего раунда.
    </p>
    <p>
      <b><span className={'text-construction'}>Бесплатный перехват при покупке.</span></b>{' '}
      В момент покупки политики игра предложит <b>перехватить
      инициативу бесплатно</b> — без траты действия {action}, которое обычно стоит перехват. Предложение
      появляется, только если в этом раунде инициативу ещё никто не перехватил, вы не владеете ею сами, а её
      владелец не изоляционист.
    </p>
    <p>
      <b><span className={'text-construction'}>Скидка на особые строения.</span></b>{' '}
      <b>−1 монета</b> {coins} на <b>любое</b> особое строение
      {specialBuilding}: Дворец, Склад, Лагерь, Арсенал, Храм, Гильдию и Крепость.
    </p>
    <p>
      <b><span className={'text-construction'}>Бой на своей земле.</span></b>{' '}
      Отряд {unit} получает <b>+1</b> к урону {damage} в ближнем бою, если стоит
      на ячейке <b>своего</b> города {city}. Суммарный бонус не может превысить размер {size} отряда.
    </p>
  </>
);

export const POLICY_DETAILED_RULES = {
  [POLICIES.DESPOTISM]: DespotismRules,
  [POLICIES.MILITARISM]: MilitarismRules,
  [POLICIES.INDUSTRIALISM]: IndustrialismRules,
  [POLICIES.PATRIOTISM]: PatriotismRules,
  [POLICIES.OLIGARCHY]: OligarchyRules,
  [POLICIES.HEGEMONISM]: HegemonismRules,
  [POLICIES.BARBARISM]: BarbarismRules,
  [POLICIES.TOTALITARIANISM]: TotalitarianismRules,
  [POLICIES.SERVARIANISM]: ServarianismRules,
  [POLICIES.FORTIFICATIONISM]: FortificationismRules,
  [POLICIES.ECOANARCHISM]: EcoanarchismRules,
  [POLICIES.THEOCRACY]: TheocracyRules,
  [POLICIES.FANATICISM]: FanaticismRules,
  [POLICIES.AGRARIANISM]: AgrarianismRules,
  [POLICIES.ISOLATIONISM]: IsolationismRules,
};

export default POLICY_DETAILED_RULES;
